module.exports = __webpack_public_path__ + "img/6.f3e918a4.png";